/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/
import { postRequestWithToken } from "./helper"


export const addLanguage = (data) => postRequestWithToken(data, 'admin/add-language');
export const updateLanguage = (data) => postRequestWithToken(data, 'admin/update-language');
export const changeLanguageStatus = (data) => postRequestWithToken(data, 'admin/change-status-language');
export const languageList = (data) => postRequestWithToken(data, 'admin/language-list');
export const uploadFile = (data) => postRequestWithToken(data, 'upload-file');
